import { getBlog, likedBlog, savedBlog } from "./blogApi";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
    blog: {},
    isLoading: false,
    isError: false,
    error: "",
};

// async thunk
export const fetchBlog = createAsyncThunk("blog/fetchBlog", async (id) => {
    const blog = await getBlog(id);
    return blog;
});

export const fetchBlogLiked = createAsyncThunk(
    "blog/likedBlog",
    async ({ id, likes }) => {
        const blog = await likedBlog({ id, likes });
        return blog;
    }
);

export const fetchBlogSaved = createAsyncThunk(
    "blog/fetchBlogSaved",
    async ({ id, isSaved }) => {
        const blog = await savedBlog({ id, isSaved });
        return blog;
    }
);

const blogSlice = createSlice({
    name: "blog",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchBlog.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(fetchBlog.fulfilled, (state, action) => {
                state.isLoading = false;
                state.blog = action.payload;
            })
            .addCase(fetchBlog.rejected, (state, action) => {
                state.isLoading = false;
                state.blog = {};
                state.isError = true;
                state.error = action.error?.message;
            })
            .addCase(fetchBlogLiked.fulfilled, (state) => {
                state.isLoading = false;
                state.blog.likes += 1;
            })
            .addCase(fetchBlogLiked.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.error?.message;
            })
            .addCase(fetchBlogSaved.fulfilled, (state) => {
                state.isLoading = false;
                state.blog.isSaved = !state.blog.isSaved;
            })
            .addCase(fetchBlogSaved.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.error?.message;
            });
    },
});

export default blogSlice.reducer;
